<template>
  <div id="accordion">
    <div class="card">
      <div
        class="card-header"
        id="headingOne"
        data-toggle="collapse"
        :data-target="'#' + id"
        aria-expanded="true"
      >
        <h5 class="mb-0">
          <button class="btn btn-link" id="title">
            <h3>{{ title }}</h3>
          </button>
        </h5>
      </div>

      <div
        :id="id"
        class="collapse"
        aria-labelledby="headingOne"
        data-parent="#accordion"
      >
        <div class="card-body">
          <p>
            {{ description }}
          </p>
          <p class="subtitle">O que procuramos?</p>
          <p id="offer" v-html="profile"></p>
          <p class="subtitle">O que oferecemos?</p>
          <p id="offer" v-html="offer"></p>
          <button
            id="candidatar"
            class="btn float-right"
            data-toggle="modal"
            :data-target="'#' + id + 'modal'"
          >
            Candidatar-me
          </button>
          <div
            class="modal fade bd-example-modal-xl"
            :id="id + 'modal'"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal-dialog-centered modal-xl"
              role="document"
            >
              <div class="modal-content">
                <div class="modal-header">
                  <h2 class="modal-title w-100 text-center" id="titleModal">
                    {{ title }}
                  </h2>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <FormCandidates :id="id"></FormCandidates>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FormCandidates from "../components/FormCandidate";
export default {
  name: "Application",
  components: {
    FormCandidates,
  },
  props: {
    id: Number,
    title: String,
    description: String,
    profile: String,
    offer: String,
  },
};
</script>
<style scoped>
.subtitle {
  font-weight: bold;
}
#title {
  color: white;
  text-decoration: none;
}
#accordion {
  padding: 20px 200px 0px 200px;
}

.card-header {
  background-color: #888888;
}
.modal {
  background: #f7951e15;
}
.modal-content {
  border: 3.5px solid #f7941e;
  border-radius: 0px;
}
.modal-header {
  border-bottom: 0 none;
}

h2 {
  font-family: "Barlow", sans-serif;
  font-weight: 500;
  font-size: 40px;
}
#candidatar {
  padding: 10px 10px 10px 10px;
  margin-bottom: 20px;
  background-color: rgb(247, 149, 29);
  border: none;
  color: white;
}
#candidatar:focus {
  box-shadow: none;
}
#candidatar:hover {
  box-shadow: #888888;
  background-color: #888888;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
}
#titleModal {
  text-align: center;
}
.card {
  background: #fff;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  cursor: pointer;
}
#offer {
  margin-left: 50px;
}
.card:hover {
  box-shadow: 0 6px 10px #888888, 0 0 6px #888888;
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
}
.card:hover >>> .card-header {
  background-color: #f7941e;
}
@media (max-width: 1000px) {
  #accordion {
    padding: 10px 5px 0px 5px;
  }
}
</style>
